var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBankIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#348ED8",
    d: "M22.298 5.617H1.702v-2.34L12 0l10.298 3.277v2.34z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D7DBE",
    d: "M12 4.213c.776 0 1.404-.629 1.404-1.404 0-.776-.628-1.405-1.404-1.405-.775 0-1.404.629-1.404 1.405 0 .775.629 1.404 1.404 1.404z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#3289D1",
    d: "M2.638 7.49h2.809v10.765H2.638V7.49zM7.787 7.49h2.809v10.765H7.787V7.49zM13.404 7.49h2.809v10.765h-2.809V7.49zM18.553 7.49h2.809v10.765h-2.809V7.49z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D7DBE",
    d: "M2.638 7.49h2.809v1.404H2.638V7.489zM7.787 7.49h2.809v1.404H7.787V7.489zM13.404 7.49h2.809v1.404h-2.809V7.489zM18.553 7.49h2.809v1.404h-2.809V7.489z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#348ED8",
    d: "M1.702 18.255h20.596V22H1.702v-3.745z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D7DBE",
    d: "M6.383 18.255h11.234V22H6.383v-3.745z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C86D1",
    d: "M6.383 20.128h11.234V22H6.383v-1.872z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B78B7",
    d: "M6.383 19.66h11.234v.935H6.383v-.936z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C86D1",
    d: "M21.362 7.49H2.638l-.936-.937v-.936h20.596v.936l-.936.937z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D7DBE",
    d: "M8.723 2.809h.937v.936h-.937v-.936zM14.34 2.809h.937v.936h-.936v-.936z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankIcon);
export default __webpack_public_path__ + "static/media/bank-icon.63cebd7e630b23264efe0a83efaeb666.svg";
export { ForwardRef as ReactComponent };